import { render, staticRenderFns } from "./FormRL04.vue?vue&type=template&id=1d2b21c2"
import script from "./FormRL04.vue?vue&type=script&lang=js"
export * from "./FormRL04.vue?vue&type=script&lang=js"
import style0 from "./FormRL04.vue?vue&type=style&index=0&id=1d2b21c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports